import React, { useState, useEffect } from "react";
import { Image, Plus, X } from "lucide-react";
import FeaturedWorkModal from "./FeaturedModal";

import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper/modules';

// Swiper Styles
import 'swiper/css';
import 'swiper/css/pagination';

const FeaturedWork = ({ value = [], onChange }) => {
  const [items, setItems] = useState(Array.isArray(value) ? value : []);
  const [openModal, setOpenModal] = useState(false);

  useEffect(() => {
    setItems(Array.isArray(value) ? value : []);
  }, [value]);

  const handleAdd = (item) => {
    const next = [...items, item];
    setItems(next);
    onChange && onChange(next);
  };

  const handleRemove = (id) => {
    const next = items.filter((it) => it.id !== id);
    setItems(next);
    onChange && onChange(next);
  };

  return (
    // <div className="rounded-2xl bg-white border p-6">
    <div className="w-full">
      <style jsx global>{`
        .featured-swiper .swiper-pagination-bullets {
          bottom: 40px !important;
          display: flex;
          justify-content: center;
          gap: 6px;
          z-index: 50 !important;
        }

        .featured-swiper .swiper-pagination-bullet {
          width: 28px;
          height: 3px;
          border-radius: 2px;
          background: #ffffff;
          opacity: 1;
          margin: 0 !important;
          transition: all 0.3s ease;
        }

        .featured-swiper .swiper-pagination-bullet-active {
          background: #E8D1AB;
          width: 40px;
        }
      `}</style>
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-lg font-semibold">Featured Work</h4>

        {items.length > 0 &&
          <div>
            <button
              className="inline-flex items-center gap-2 text-sm"
              onClick={() => setOpenModal(true)}
            >
              <div className="p-2 rounded-full border border-black/10 hover:bg-black/5">
                <Plus className="w-4 h-4 text-black" />
              </div>
              <span>Add another</span>
            </button>
          </div>
        }
      </div>

      {/* empty state */}
      {items.length === 0 ? (
        <div className="h-20 border border-dashed rounded-lg flex items-center justify-center text-muted-foreground">
          <button
            className="inline-flex items-center gap-2 text-sm"
            onClick={() => setOpenModal(true)}
          >
            <Plus size={16} /> {items.length ? "Add another" : "Add"}
          </button>
        </div>
      ) : (
        <div className="grid grid-cols-1 gap-4">
          {items.map((it) => {
            const images = it.previews?.length ? it.previews : it.image ? [it.image] : [];
            return (
            <div
                key={it.id}
                className="relative group bg-[#1A1A1A] rounded-[12px] overflow-hidden border border-white/10 hover:border-[#E8D1AB]/40 transition"
              >
                {/* Media Section */}
                <div className="relative w-full h-48 lg:h-56 bg-[#262626] flex overflow-hidden">
                  {images.length > 0 ? (
                    <Swiper
                      modules={[Pagination]}
                      pagination={{ clickable: true }}
                      className="featured-swiper w-full h-full relative z-20"
                    >
                      {images.map((src, idx) => (
                        <SwiperSlide key={idx}>
                          <img
                            src={src}
                            alt={`${it.title} ${idx + 1}`}
                            className="w-full h-full object-cover"
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  ) : (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <Image className="w-10 h-10 text-white/10" />
                    </div>
                  )}

                  {/* Remove button */}
                  <button
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemove(it.id);
                    }}
                    className="absolute top-3 right-3 bg-black/60 hover:bg-red-500 text-white rounded-full p-2 z-50 transition-colors backdrop-blur-sm"
                    aria-label="Remove"
                  >
                    <X size={16} />
                  </button>
                </div>

                {/* Content section */}
                <div className="absolute bottom-0 left-0 w-full p-2.5 z-30 pointer-events-none">
                  {/* Subtle gradient overlay for text readability */}
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent -z-10" />

                  <h5 className="text-base font-bold text-white mb-2">
                    {it.title}
                  </h5>

                  <div className="flex gap-2 flex-wrap">
                    {it.tags?.map((t) => (
                      <span
                        key={t}
                        className="bg-[#E8D1AB] text-black px-2.5 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider"
                      >
                        {t}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
          )})}
        </div>
      )}

      <FeaturedWorkModal
        open={openModal}
        onClose={() => setOpenModal(false)}
        onAdd={handleAdd}
      />
    </div>
  );
}

export default FeaturedWork
